import { ChangeDetectionStrategy, Component, TemplateRef, contentChild, input, ViewEncapsulation } from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';
import { InputIconModule } from 'primeng/inputicon';

import { FcpFloatLabelComponent } from '../fcp-float-label/fcp-float-label.component';
import { FcpIconFieldComponent, IconFieldPosition } from '../fcp-icon-field/fcp-icon-field.component';

@Component({
    selector: 'fcp-input-field',
    standalone: true,
    imports: [FcpIconFieldComponent, FcpFloatLabelComponent, InputIconModule, NgTemplateOutlet],
    styleUrl: './fcp-input-field.component.less',
    encapsulation: ViewEncapsulation.Emulated,
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `<div class="fcp-input-field-container">
        @if (floatLabel()) {
            <fcp-float-label [invalid]="invalid()">
                <fcp-icon-field [iconPosition]="iconPosition()">
                    @if (iconStyleClass() && iconPosition() === inputFieldIconPosition.Left) {
                        <p-inputicon [styleClass]="iconStyleClass()" />
                    }
                    <ng-container [ngTemplateOutlet]="inputTemplate() ?? null" />
                    @if (iconStyleClass() && iconPosition() === inputFieldIconPosition.Right) {
                        <p-inputicon [styleClass]="iconStyleClass()" />
                    }
                </fcp-icon-field>
                <label [for]="id()">{{ label() }}</label>
            </fcp-float-label>
        } @else {
            <fcp-icon-field [iconPosition]="iconPosition()">
                @if (iconStyleClass() && iconPosition() === inputFieldIconPosition.Left) {
                    <p-inputicon [styleClass]="iconStyleClass()" />
                }
                <ng-container [ngTemplateOutlet]="inputTemplate() ?? null" />
                @if (iconStyleClass() && iconPosition() === inputFieldIconPosition.Right) {
                    <p-inputicon [styleClass]="iconStyleClass()" />
                }
            </fcp-icon-field>
        }
        @if (hintText()) {
            <small class="fcp-input-field-hint" [class.fcp-input-field-hint-invalid]="invalid()">{{
                hintText()
            }}</small>
        }
    </div>`
})
export class FcpInputFieldComponent {
    readonly inputFieldIconPosition = InputFieldIconPosition;

    label = input<string>('');
    id = input<string | undefined>(undefined);
    iconStyleClass = input<string | null>(null);
    iconPosition = input<InputFieldIconPosition>(InputFieldIconPosition.Left);
    hintText = input<string | null>(null);
    invalid = input<boolean>(false);
    floatLabel = input<boolean>(false);

    inputTemplate = contentChild(TemplateRef);
}

export enum InputFieldIconPosition {
    Left = IconFieldPosition.Left,
    Right = IconFieldPosition.Right
}
